import type { FC } from 'react';
import { Modal } from '@interstate/components/Modal';
import { ConflictTemplatesMessage } from '../manageTemplate/ManageTemplatesWrapper.style';
import { TEST_IDS } from '../constants';

export interface TemplateAutoApplyConflictModalProps {
    show: boolean;
    templatesWithConflict: string[];
    onCancel: () => void;
    onConfirm: () => void;
}

export const TemplateAutoApplyConflictModal: FC<TemplateAutoApplyConflictModalProps> = ({
    show,
    templatesWithConflict,
    onCancel,
    onConfirm
}) => {
    return (
        <Modal
            show={show}
            size="large"
            header="Override an Existing Auto-Applied Template"
            onHide={onCancel}
            footer={{
                primary: {
                    label: 'Apply Template',
                    action: onConfirm,
                    'data-testid': TEST_IDS.CONFIRM_AUTO_APPLY_TEMPLATE,
                    buttonStyle: 'primary'
                },
                options: [
                    {
                        label: 'Cancel',
                        action: onCancel,
                        'data-testid': TEST_IDS.CANCEL_AUTO_APPLY_TEMPLATE,
                        buttonStyle: 'tertiary'
                    }
                ]
            }}
        >
            <ConflictTemplatesMessage>
                This configuration is already set to auto-apply in the <strong>{templatesWithConflict?.join(',')}</strong> template.
                Would you like to override the <strong>{templatesWithConflict?.join(',')}</strong> with auto-apply with this new
                one?
            </ConflictTemplatesMessage>
        </Modal>
    );
};
